import { render, staticRenderFns } from "./editReserveParams.vue?vue&type=template&id=27b66f24"
import script from "./editReserveParams.vue?vue&type=script&lang=js"
export * from "./editReserveParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports